"use client"

import { usePathname } from "next/navigation"
import { useEffect } from "react"

// T13: Google Ads solo se configura en rutas de conversión (carrito,
// checkout y confirmación de pedido). gtag() ya existe globalmente
// (layout.tsx, con Consent Mode v2), así que el config del módulo de Ads
// solo se dispara cuando hace falta: el resto del sitio no carga el
// módulo de Ads (menos red/JS) y las conversiones siguen funcionando.
const CONVERSION_ROUTE = /^\/(es\/)?(cart|checkout|order)(\/|$)/

const GOOGLE_ADS_ID = "AW-1010829742"

export default function GoogleAdsRoute() {
  const pathname = usePathname()

  useEffect(() => {
    if (CONVERSION_ROUTE.test(pathname)) {
      ;(window as unknown as { gtag?: (...args: unknown[]) => void }).gtag?.(
        "config",
        GOOGLE_ADS_ID
      )
    }
  }, [pathname])

  return null
}
